import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bidding-rounds',
  templateUrl: './bidding-rounds.component.html',
  styleUrls: ['./bidding-rounds.component.css']
})
export class BiddingRoundsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
